import { EditButton, EditButtonProps } from '@refinedev/antd';
import { useGo, useResourceParams } from '@refinedev/core';
import type { PointerEvent } from 'react';

import { usePermissionContext } from '@/contexts/PermissionContext';

import { useCountryEnforcer } from '../general/CountryEnforcer';

interface ProtectedEditButtonProps extends EditButtonProps {
  keepQuery?: boolean;
}

const ProtectedEditButton = ({
  keepQuery = false,
  recordItemId,
  resource: resourceNameFromProps,
  meta,
  onClick,
  disabled,
  ...rest
}: ProtectedEditButtonProps) => {
  const { hasPermission } = usePermissionContext();
  const { blockEditForCountry } = useCountryEnforcer();
  const go = useGo();
  const { resource, identifier } = useResourceParams({ resource: resourceNameFromProps });
  const resolvedResource = resourceNameFromProps ?? identifier ?? resource?.name;
  const canKeepQuery = keepQuery && resolvedResource && recordItemId != null;
  const handleClick = (event: PointerEvent<HTMLButtonElement>) => {
    onClick?.(event);
    if (!canKeepQuery) {
      return;
    }

    go({
      to: { resource: resolvedResource, action: 'edit', id: recordItemId, meta },
      options: { keepQuery: true },
    });
  };

  return hasPermission('edit') ? (
    <EditButton
      className="ProtectedEditButton"
      recordItemId={recordItemId}
      resource={resourceNameFromProps}
      meta={meta}
      onClick={canKeepQuery ? handleClick : onClick}
      disabled={disabled || blockEditForCountry}
      {...rest}
    />
  ) : null;
};

export default ProtectedEditButton;
